export const OVERVIEW = {
  title: "Insights and Recommendations",
  link: "/insights",
  body: "This portal shares the insights and recommendations of  FMCS staff across tenures based on their personal experiences of organizational culture.",
};
